import { ChatMessage } from '@/interface';
import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const chatStatus = createSelector(
  [(state: RootState) => state.chat.chatSuccess],
  chatSuccess => chatSuccess,
);

export const chatFailureStatus = createSelector(
  [(state: RootState) => state.chat.chatFailure],
  chatFailure => chatFailure,
);

export const chatMessagesSelector = (id: number) => createSelector(
  [(state: RootState) => state.chat.chatData[id]?.messages || [] as ChatMessage[]],
  messages => messages,
);

export const chatLoadingSelector = (id: number) => createSelector(
  [(state: RootState) => state.chat.chatData[id]?.isLoading || false],
  isLoading => isLoading,
);